export function getPropertyChatTripType(isOnTrip) {
  return isOnTrip ? 'on trip' : 'upcoming trip';
}

export function isPropertyChatEnabled(booking) {
  return Boolean(booking?.property?.chatEnabled);
}

export function getPropertyChatEventParams(isOnTrip, { propertyChatFlag } = {}) {
  const params = { trip_type: getPropertyChatTripType(isOnTrip) };

  if (propertyChatFlag !== undefined) {
    params.property_chat_flag = propertyChatFlag;
  }

  return params;
}

export function shouldShowPropertyChatAppCallout({
  booking,
  loading,
  isCancelledTrip,
  isUpcomingTrip,
  isOnTrip,
  isCheckedOutToday,
}) {
  if (!booking || loading) {
    return false;
  }
  if (isCancelledTrip) {
    return false;
  }
  if (!isPropertyChatEnabled(booking)) {
    return false;
  }
  return isUpcomingTrip || isOnTrip || isCheckedOutToday;
}
